/**
 * http://angular-data.pseudobry.com/documentation/guide/angular-cache/index
 */
tnFontsCacheFactory.$inject = ['CacheFactory'];
export function tnFontsCacheFactory(CacheFactory) {
    const maxAge = 86400000; // one day
    CacheFactory('peopleCache', {
        maxAge: maxAge,
        storageMode: 'localStorage',
    });
    CacheFactory('categoriesCache', {
        maxAge: maxAge,
        storageMode: 'localStorage',
    });
}
